import { translate } from 'react-i18next';
import { compose, hoistStatics, withState, lifecycle, withHandlers, withProps } from 'recompose';
import { connect } from 'react-redux';
import AttachedFile from './AttachedFile';
import flh from '../../../helpers/file.helper';

const toggleModal = props => (e, activeStatus) => {
  e.preventDefault();
  props.setActiveModal(activeStatus);
};

const checkFileType = (props) => {
  if (props.file && props.file.type && props.file.type.startsWith('image')) {
    return true;
  }
};

const onClick = props => (e) => {
  const { upload, file, isImage } = props;
  if (!upload || file.type) {
    if (isImage) {
      e.preventDefault();
      toggleModal(props)(e, true);
    } else if (upload) {
      e.preventDefault();
    }
  } else {
    e.preventDefault();
  }
};

const checkShowDelete = (props) => {
  let showDelete = true;
  if (props.viewOnly) showDelete = false;
  else if (props.canDelete) showDelete = true;
  else if (props.upload) {
    if (props.file && props.file.uploadingPc !== 100) {
      showDelete = false;
    }
    if (props.file && props.file.message) {
      showDelete = false;
    }
  }
  return showDelete;
};


const mapStateToProps = state => ({
  token: state.auth.token,
});

const enhance = compose(
  translate('portal'),
  connect(mapStateToProps, null),
  withState('activeModal', 'setActiveModal', false),
  withProps(props => ({
    isImage: checkFileType(props),
    showDelete: checkShowDelete(props),
    downloadLink: props.file && props.file.id ? flh.createDownloadLink(props.file.id, props.token) : '#',
  })),
  withHandlers({
    toggleModal,
    onClick,
  }),
);

export default hoistStatics(enhance)(AttachedFile);



// WEBPACK FOOTER //
// ./src/components/files/attachedFile/index.js